import { type FragmentType, getFragmentData } from '@packages/gql/generated/shopping';
import { Dialog } from '@packages/shared';
import { View3D32 } from '@packages/themes/icons';
import { MazingFragmentFragmentDoc } from '@packages/gql/generated/shopping/MazingFragmentFragmentDoc';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { ImageGalleryCallToActionButton } from '../ImageGalleryCallToActionButton';
import { MazingRenderer } from './MazingRenderer';
import { messages } from './message';
import { useMazingTracking } from '../Tracking/hooks/useMazingTracking';

/* GraphQL */ `
  fragment MazingFragment on Product {
    mazingUrl
  }
`;

export type MazingProps = {
  data: FragmentType<typeof MazingFragmentFragmentDoc>;
};

/**
 *
 * This component shows 3D model of the product.
 * It will show a button on the image gallery, which will open a dialog with the 3D model.
 *
 */
export const Mazing = ({ data }: MazingProps) => {
  const [openDialog, setOpenDialog] = useState<boolean>(false);
  const { mazingUrl } = getFragmentData(MazingFragmentFragmentDoc, data);

  const { formatMessage } = useIntl();
  const { trackGlycerinDisplayButton } = useMazingTracking();

  useEffect(() => {
    trackGlycerinDisplayButton();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openDialogHandler = () => {
    setOpenDialog(true);
  };

  return (
    <>
      <ImageGalleryCallToActionButton
        onClick={openDialogHandler}
        clickTrackingProps={{ category: '3D_Button', detail: 'Mazing' }}
        aria-label={formatMessage(messages.buttonLabel)}
      >
        <View3D32 />
      </ImageGalleryCallToActionButton>
      <Dialog
        displayTrackingProps={{ category: '3D_dialog', detail: 'Mazing' }}
        fullScreen
        open={openDialog}
        handleClose={() => setOpenDialog(false)}
        title={formatMessage(messages.mazingDialogTitle)}
        dialogContent={<MazingRenderer mazingUrl={mazingUrl!} />}
      />
    </>
  );
};
